import { ColumnSetting } from '../../../_foundation/models/grid.models';

export const columns: ColumnSetting[] = [
  {
    field: 'operationClassification',
    title: 'Operation Classification',
    filter: 'text',
    width: 150
  },
  {
    field: 'operationName',
    title: 'Operation Step Name',
    filter: 'text',
    width: 150
  },
  {
    field: 'startTimeShow',
    title: 'Start',
    filter: 'text',
    width: 100
  },
  {
    field: 'endTimeShow',
    title: 'End',
    filter: 'text',
    width: 100
  },
  {
    field: 'error',
    title: 'Error',
    filter: 'text',
    width: 250
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 140
  }
];



// WEBPACK FOOTER //
// ./src/pages/validation/gap-overlap/gap-overlap.config.ts